import styled, { css } from 'styled-components';
import { ButtonStyled } from '../ui';
import { hexToRGBa } from '../../helpers';
import { devices } from '../breakpoints';

interface IPageStyledProps {
	buttonCount?: number;
	horizontal?: boolean;
}

interface IStatusMessage {
	error?: boolean;
}

interface IPageControlsSectionProps {
	notEmpty: boolean;
}
interface IHorizontalProps {
	horizontal?: boolean;
}
export const PageStyled = styled.div<IPageStyledProps>`
	width: 100%;
	height: 100%;
	${({ buttonCount, horizontal }) =>
		buttonCount && buttonCount > 0
			? horizontal
				? 'padding-bottom: 96px;'
				: `padding-bottom: ${46 + 50 * buttonCount}px;`
			: 'padding-bottom: 16px;'}
`;
export const PageSubtitle = styled.div`
	${({ theme }) => theme.mixin.subtitle()};
`;

export const PageMainContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
`;
export const PageControlsSection = styled.div<IPageControlsSectionProps>`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	${({ notEmpty }) => `padding: ${notEmpty ? '16px' : '0'}`};
	background-color: ${({ theme }) => theme.color.white};
	border-top: 1px solid ${({ theme }) => theme.color.porcelainLight};
`;
export const PageShadowWrapper = styled.div<IHorizontalProps>`
	width: 100%;
	${({ horizontal }) =>
		horizontal &&
		css`
			display: flex;
			align-items: center;
			justify-content: space-between;

			${ButtonStyled} {
				margin-bottom: 0;
				margin-right: 16px;

				&:last-child {
					margin-right: unset;
				}
			}
		`}
`;
export const PageShadow = styled.div`
	position: absolute;
	height: 71px;
	left: 0;
	right: 0;
	top: -71px;
	background: linear-gradient(180deg, #cecece 0%, ${hexToRGBa('#cecece', 0)} 100%);
	opacity: 0.8;
	transform: rotate(-180deg);
	pointer-events: none;
`;
export const PageHeader = styled.header`
	margin-bottom: 32px;
	width: 100%;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: unset;
	padding: 16px 0;
	box-sizing: border-box;
	max-height: 150px;
	height: 100%;
	${devices.phone} {
		overflow: initial;
		height: 150px;
		margin-bottom: 0;
	}
	img {
		border-radius: 4px;
		width: auto !important;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		${devices.phone} {
			width: 100%;
			padding: 16px;
		}
	}
`;

export const PageContent = styled.div`
	width: 100%;
`;
export const StatusMessage = styled.div<IStatusMessage>`
	width: 100%;
	background: ${({ theme, error }) => (error ? theme.color.wePeep : theme.color.iceberg)};
	border-radius: 4px;
	padding: 11px;
	box-sizing: border-box;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	font-size: 14px;
	color: ${({ theme, error }) => (error ? theme.color.cerise : theme.color.gossamer)};
	margin-bottom: 16px;
`;
